// useHoldingsForPlan — the Retire confirm's holdings, re-judged the moment they go old.
//
// holdingsForPlan (custody-keys-replace.ts) decides from the clock whether a holdings answer is still known — but
// only when something renders. With the confirm open, a refresh that pauses offline notifies nothing, so "holds 0"
// stayed on screen past its 60 s (Astra round e #4, 27 Oct 2026; its probe of the observer: zero notifications).
// This hook draws the confirm again at the instant the answer goes old, and reads fetchStatus so a pause itself
// redraws it (react-query notifies only on what a render read). Both Keys screens use it.

import { useEffect, useState } from 'react';
import { holdingsForPlan, holdingsGoOldAt, type HoldingsRead } from './custody-keys-replace';

export function useHoldingsForPlan<T>(q: HoldingsRead<T>, open: boolean): T | null {
  const [, redraw] = useState(0);
  const goesOldAt = open ? holdingsGoOldAt(q) : null;
  useEffect(() => {
    if (goesOldAt === null) return undefined;
    const timer = setTimeout(() => redraw((n) => n + 1), Math.max(0, goesOldAt - Date.now()) + 1);
    return () => clearTimeout(timer);
  }, [goesOldAt]);
  return holdingsForPlan(q);
}
